import { useEffect, useState } from "react";
import DadosExameManager from "../dadosExameManager";

export const useExame = (atualizarLoadings, setFocus, ehVeterinario, handleChange, idContrato) => {
  const [listaExamesContratoLicitacao, setListaExamesContratoLicitacao] = useState([]);
  const [listaFiltradaExamesContrato, setListaFiltradaExamesContrato] = useState([]);

  useEffect(() => {
    async function atualizarListaRelacionamentoExame(contratoLicitacao) {
      var retorno = await DadosExameManager.listaExamesContratoLicitacao(contratoLicitacao);

      setListaExamesContratoLicitacao(
        retorno.lista
          ? retorno.lista.map(exame => {
            return {
              codigo: exame.mnemonico,
              label: `${exame.mnemonico}-${exame.material} ${exame.nome}`,
              pesquisa: `${exame.mnemonico} ${exame.material} ${exame.nome} ${exame.palavrasChaves}`,
              ...exame
            };
          })
          : []
      );
    }

    if (idContrato && idContrato > 0) atualizarListaRelacionamentoExame(idContrato);
  }, [idContrato]);

  useEffect(() => {
    setListaFiltradaExamesContrato(listaExamesContratoLicitacao);
  }, [listaExamesContratoLicitacao]);

  async function atualizarDadosExame(exame) {
    if (exame) {
      handleChange("exame", exame);
      setFocus(true);
    } else {
      handleChange("exame", null);
    }
    atualizarLoadings(true, true);
  }

  const handleChangeAutocompleteExame = event => {
    atualizarDadosExame(event);
  };

  const atualizarListaExames = async (inputValue, material) => {
    if (inputValue === null || inputValue === "") {
      return [];
    }
    const retorno = await DadosExameManager.listaExames(inputValue, ehVeterinario, material);
    if (!retorno || retorno.erro) {
      return [];
    } else {
      return retorno.lista;
    }
  };

  const handleAtualizarFiltroExames = (listaFiltrada) => {
    setListaFiltradaExamesContrato(listaFiltrada);
  };

  return {
    listaExamesContratoLicitacao: listaExamesContratoLicitacao,
    listaFiltradaExamesContrato: listaFiltradaExamesContrato,
    atualizarDadosExame: atualizarDadosExame,
    handleChangeAutocompleteExame: handleChangeAutocompleteExame,
    handleAtualizarFiltroExames: handleAtualizarFiltroExames,
    atualizarListaExames: atualizarListaExames
  };
};
